import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { QuoteDTO } from '../../interfaces/models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class QuoteOfferService {

  constructor(
    protected httpClient: HttpClient,
  ) {
  }

  public offerDiscount(data: {
    id: number;
    discount: number;
    pickDate: Date;
    deliveryDate: Date;
  }): Observable<QuoteDTO> {
    const { id, discount, pickDate, deliveryDate } = data;
    return this.httpClient.post<QuoteDTO>(
      `${environment.api}/quote-offers/${id}`,
      {
        discount,
        pickDate,
        deliveryDate,
      },
    );
  }
}
